import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { MajorProgram } from './../builders/major_programs_builder';

angular
  .module('major-explorer-data')
  .service('deleteMetaRankingCommand', ($http: ng.IHttpService, defineCommand: IDefineCommand) => {
    return defineCommand('deleteMetaRankingCommand', (deferred: ng.IDeferred<any>, majors: MajorProgram[]) => {
      const payload: { unranked_metamajor_nks: string[] } = {
        unranked_metamajor_nks: []
      };

      _4.forEach(majors, (major: MajorProgram) => {
        payload.unranked_metamajor_nks.push(major.nk);
      });

      $http
        .delete('/programpicker/student/metamajor/', {
          headers: {
            'Content-Type': 'application/json'
          },
          data: payload
        })
        .then(
          (response) => {
            deferred.resolve(response.data);
          },
          (response) => {
            deferred.reject(response.data);
          }
        );
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/delete_metaranking_command.ts